import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { ActivityOwnerList } from '../Components/ActivityOwnerList'
import { ACTIVITY_RESOURCE } from '../Contracts/Activity.types'

import type { ActivityOwnerKind } from '../Contracts/Activity.types'

export interface OwnerActivitiesTabProps {
    owner: ActivityOwnerKind
    /** Значення форми власника; без `uuid` (новий власник) справ ще немає */
    record: { uuid?: unknown; '@id'?: unknown; title?: unknown } | undefined
    /** `full` — вкладка, `compact` — блок на «Загальному» */
    mode?: 'full' | 'compact'
}

/** Чи бачить користувач справи взагалі (`SPEC-011` §8.6, В4): колекційне `read_collection`. */
export const canReadActivities = (): boolean => CheckGlobalResourceAccessTask(ACTIVITY_RESOURCE, 'read_collection')

/**
 * Публічне API контейнера справ для карток власників (`SPEC-011` §8.6,
 * `SPEC-002` §2.2): обгортка `CrmActivitiesTab` бере вміст вкладки
 * «Справи» звідси, а не імпортом з надр контейнера.
 *
 * Без права на справи — нічого (у легасі вкладка показувала 403 усередині);
 * без збереженого власника — теж: справи заводять лише існуючому.
 */
export const OwnerActivitiesTab = ({ owner, record, mode = 'full' }: OwnerActivitiesTabProps) => {
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (uuid === null || !canReadActivities()) return null

    const iri = record?.['@id']
    const title = record?.title

    return (
        <ActivityOwnerList
            owner={owner}
            mode={mode}
            record={{
                uuid,
                ...(typeof iri === 'string' && iri !== '' ? { '@id': iri } : {}),
                ...(typeof title === 'string' && title !== '' ? { title } : {}),
            }}
        />
    )
}
